export const TEMPLATE_HEADERS = [
  'chat_id',
  'order_guide_id',
  'category',
  'product_id',
  'product_name',
  'unit',
  'par',
  'currency',
  'price',
  'display_name',
];

export const TEMPLATE_FILE_NAME = 'order-guide-upload-template.csv';

export const buildTemplateCsv = (): string => `${TEMPLATE_HEADERS.join(',')}\n`;

/** Triggers a browser download of the empty CSV template */
export const downloadTemplateCsv = (): void => {
  const blob = new Blob([buildTemplateCsv()], {
    type: 'text/csv;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = TEMPLATE_FILE_NAME;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
};
